import React, { Component } from "react";
import { getDateRange } from "../utils/Utils";
import moment, { Moment } from "moment";
import {Link} from "react-router-dom";
import _ from "lodash";

export interface TableBoxDataViewItem {
    date: string,
    title: string,
    linkTo?: string,
    backgroundColour?: string,
    className?: string
}

interface TableBoxDataViewProps {
    startDate: string;
    endDate: string;

    data: TableBoxDataViewItem[];
}

interface TableBoxDataViewState {

}

export default class TableBoxDataView extends Component<TableBoxDataViewProps, TableBoxDataViewState>
{
    public componentDidMount() {

    }

    private getItemsInDay(date: Moment): TableBoxDataViewItem[] {
        let itemsInDay = this.props.data.filter(d => moment(d.date).isSame(date, 'date'));
        itemsInDay = _.sortBy(itemsInDay, i=> i.date);
        
        // Default for day if no data
        if (itemsInDay.length < 1) {
            itemsInDay.push({
                backgroundColour: "none",
                date: date.format("YYYY-MM-DD"),
                title: `${date.format("YYYY-MM-DD")}\nNo Data`
            })
        }

        return itemsInDay;
    }

    private renderRecord(numberOfItemsInDay: number, item: TableBoxDataViewItem) {

        const style: React.CSSProperties = {width: `${100 / numberOfItemsInDay}%`};
        if(item.backgroundColour)
        {
            style.background = item.backgroundColour;
        }
        
        const recordProps: any = {
            className: `table-box-data-view__day__record ${item.className}`, 
            style: style, 
            title: item.title  
        };
        

        let RecordComponent: any = "div";
        if(item.linkTo)
        {
            RecordComponent = Link;
            recordProps.to = item.linkTo;
            recordProps.target = "_blank";
            recordProps.rel = "noopener noreferrer";
        }
        
        return (
            <RecordComponent {...recordProps}/>
        );
    }

    private renderDay(totalBoxes: number, date: Moment) {
        const itemsInDay = this.getItemsInDay(date);
        const recordsInDay = itemsInDay.map(itemInDay => this.renderRecord(itemsInDay.length, itemInDay));

        return (
            <div className="table-box-data-view__day" style={{ width: `${100 / totalBoxes}%` }}>
                {recordsInDay}
            </div>
        );
    }

    public render() {
        const dateRange = getDateRange(this.props.startDate, this.props.endDate);

        const days = dateRange.map(date => this.renderDay(dateRange.length, date));

        return (
            <div className="table-box-data-view">
                {days}
            </div>
        );
    }
}